import React from 'react';
import Loader from "react-loader-advanced";

import './index.css';

export const dots = (
  <span className="loader">
    <span className="loader__item" />
    <span className="loader__item" />
    <span className="loader__item" />
  </span>
);


class LoadingDots extends React.Component{
  render = () => (
    <Loader show={this.props.show} message={dots} backgroundStyle={{ backgroundColor: 'rgba(255,255,255,1)' }}>
      {this.props.children}
    </Loader>
  );
}

export default LoadingDots;
